import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed, PropType, ComputedRef, watch } from 'vue';
import { orderBy } from 'lodash';


import { useGetAnnotationSeveritiesQuery } from '@/entities/annotation-severity/hooks';
import { Service } from '@/entities/services/types';

import { NkOption, NkSelect } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnotationSeveritySelect',
  props: {
  service: {
    type: Number as PropType<Service['id']>,
    default: null,
  },
  preselection: {
    type: Boolean,
    default: false,
  },
},
  emits: ['pre-selection'],
  setup(__props, { emit }) {

const props = __props





const severitiesQueryFilter: ComputedRef = computed(() => ({ service: props.service || '' }));

const { data: severities, isLoading, refetch } = useGetAnnotationSeveritiesQuery({
  refetchOnWindowFocus: false,
  onSuccess: (data) => {
    console.log('on fetch');
    if (props.preselection) {
      emit('pre-selection', data.map(o => o.id));
    }
  },
}, severitiesQueryFilter);

watch(() => props.service, () => refetch.value());

const orderedData = computed(() => orderBy((severities.value || []), 'severityNumber', 'desc'));

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkSelect), _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderedData), (datum) => {
        return (_openBlock(), _createBlock(_unref(NkOption), {
          key: datum.id,
          label: datum.name,
          value: datum.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(datum.name), 1)
          ]),
          _: 2
        }, 1032, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 16)), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})